import React, { useEffect, useRef } from 'react';
import styles from './TermsContent.module.css';
import backIcon from "../icons/back_icn.png";

const TermsContent = ({ onBack }) => {
  const contentRef = useRef(null);

  useEffect(() => {
    const content = contentRef.current;

    if (content) {
      let scrollStep = 1;
      let scrollInterval;

    const startAutoScroll = () => {
      scrollInterval = setInterval(() => {
        if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
          clearInterval(scrollInterval);
        } else {
          content.scrollTop += scrollStep;
        }
      }, 50);
    };

    startAutoScroll();

    const stopAutoScroll = () => {
      clearInterval(scrollInterval);
      content.removeEventListener('wheel', stopAutoScroll);
      content.removeEventListener('touchstart', stopAutoScroll);
    };

    content.addEventListener('wheel', stopAutoScroll);
    content.addEventListener('touchstart', stopAutoScroll);

    return () => {
      content.removeEventListener('wheel', stopAutoScroll);
      content.removeEventListener('touchstart', stopAutoScroll);
      clearInterval(scrollInterval);
    };
   }
  }, []);

  return (
    <div className={styles.termsContentContainer}>
      <div className={styles.termsContent} ref={contentRef}>
      <h1>Terms & Conditions</h1>
<p><strong>Effective Date:</strong> April 30, 2026</p>

<h2>Introduction</h2>
<p>
  Welcome to the Beats Platform (operated by Quality Performance Core Ltd) ("Quality Performance Core", "qpcore", "we", "us", or "our"). By accessing or using our service that provides non-exclusive usage rights to Beats (the "Service"), you agree to these Terms & Conditions ("Terms"). Please read them carefully.
</p>

<h2>Use of the Beats</h2>
<p>
  Our platform provides a digital, intangible service granting you non-exclusive rights to use the Beats in your personal or commercial projects. This is not a sale of goods or a royalty-based transaction, but the provision of a digital service.
</p>
<p>
  You must disable Content ID systems on platforms such as YouTube, Instagram, Facebook, TikTok, and Snapchat when using these Beats, as multiple users hold similar non-exclusive rights.
</p>

<h2>User Responsibilities</h2>
<p>
  <strong>Compliance:</strong> You agree to use the Beats in accordance with all applicable laws and regulations, and according to the limitations set out in the License Agreement.
</p>
<p>
  <strong>Content ID:</strong> You must ensure that any automated Content ID claims are disabled on the above-mentioned platforms to avoid conflicts with other licensees of the same Beat.
</p>

<h2>Third-Party Services</h2>
<p>
  For analytics we currently send server-side events only to Meta (Facebook) through its Conversions API. No client-side pixels from Meta, TikTok or Twitter (X) are loaded in your browser.
</p>
<h2>Cookies and Tracking Pixels</h2>
<p>
  The platform itself does not place cookies. Paddle sets only strictly necessary cookies during checkout to finalise payment and protect against fraud; these files are essential and do not require separate consent.
</p>

<h2>Payments</h2>
<p>
  All payments for the Service are processed through the Paddle platform. By making a purchase, you agree to Paddle's Terms and Privacy Policy. Payment confirmations are received via automated notifications and delivered to your support section through a hidden email alias.
</p>
<h2>Intellectual Property</h2>
<p>
  All Beats and associated materials are owned by Quality Performance Core Ltd or its licensors and are protected by intellectual property laws. You receive a limited right to use the Beats as a digital service, not ownership of the content.
</p>

<h2>No Refund Policy</h2>
<p>
  All sales for the digital service provided by Quality Performance Core Ltd are final. Due to the intangible and immediate nature of the license granted to access and use the Beats, we do not offer refunds, exchanges, or credits once access has been provided.
</p>
<p>
  Some jurisdictions may provide certain statutory rights relating to refunds for digital products or services. Nothing in this No Refund Policy is intended to limit your rights beyond what is permitted by law.
</p>

<h2>Disclaimer of Warranties</h2>
<p>
  The Service is provided “as is” without any warranties, express or implied, including but not limited to implied warranties of merchantability or fitness for a particular purpose.
</p>

<h2>Limitation of Liability</h2>
<p>
  Quality Performance Core Ltd shall not be liable for any indirect, incidental, or consequential damages arising out of your use or inability to use the Beats or the platform.
</p>

<h2>Indemnification</h2>
<p>
  You agree to indemnify and hold harmless Quality Performance Core Ltd and its affiliates, directors, officers, employees, and agents from any claims, liabilities, damages, losses, or expenses arising from your use of the Service or violation of these Terms.
</p>

<h2>Termination</h2>
<p>
  We may suspend or terminate your access to the Service at any time, without prior notice or liability, if you breach these Terms or for any other reason. Upon termination, your right to use the Service will immediately cease and we may delete your account and data in accordance with our Privacy Policy.
</p>

<h2>Governing Law and Jurisdiction</h2>
<p>
  These Terms and any disputes arising out of or in connection with them shall be governed by and construed in accordance with the laws of United Kingdom. You agree that any dispute will be subject to the exclusive jurisdiction of the courts of United Kingdom.
</p>

<h2>Changes to Terms</h2>
<p>
  We may update these Terms periodically. Any changes will be effective upon posting to this page.
</p>

<h2>Contact Us</h2>
<p>
  If you have any questions regarding these Terms & Conditions, please contact us at contact@qpcore.com.
</p>
      </div>
      <img
	src={backIcon}
        alt="Back"
        className={`${styles.backIcon} ${styles.visible}`}
        onClick={onBack}
      />
    </div>
  );
};


export default TermsContent;

